export default "__VITE_ASSET__BcEA3fiG__"